<script>
import LocationForm from '@/components/organism/location/LocationForm'

export default {
    name: 'Step3',
    components: {
        LocationForm,
    },
    model: {
        prop: 'address',
        event: 'change',
    },
    props: {
        address: {
            type: Object,
            default: () => {},
        },
        scrollId: String,
    },
    methods: {
        onChange(address) {
            this.$emit('change', address)
        },
        verifyStep() {
            this.$refs.locationForm.verifyStep()
        },
        next() {
            this.$emit('next', 6)
        },
    },
}
</script>

<template lang="pug">
location-form(ref="locationForm" :address="address" :scroll-id="scrollId" @next="next" @change="onChange")
</template>
